(function () {
  'use strict';

  const { iman, CollectionGrids } = window.Universe;

  function init() {
    if (!iman.get('collectionGrids')) {
      iman.add('collectionGrids', new CollectionGrids());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
